export const setSettingsTableLocal = (value) => {
  localStorage.setItem('@SettingsTable', JSON.stringify(value))
}

export const getSettingsTableLocal = (cb) => {
  const value = localStorage.getItem('@SettingsTable')
  cb(JSON.parse(value))
}

